import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  current_stage_id: string().required(),
});

/**
 * CardArchivedEvent
 *
 * - Evento emitido quando um card é arquivado.
 */
export class CardArchivedEvent extends CreateCommand(RealtimeEventType.CardArchived, SCHEMA) {}
